import { create } from 'zustand';

type Payment = {
  id: number;
  setId: (id: number) => void;
};

export const usePaymentStore = create<Payment>(set => ({
  id: 0,
  setId: id => set(() => ({ id: id })),
}));

type ValorTotal = {
  valor: string;
  setValor: (valor: string) => void;
};

export const useValorTotalStore = create<ValorTotal>(set => ({
  valor: '',
  setValor: valor => set(() => ({ valor: valor })),
}));

export const useValorTitularStore = create<ValorTotal>(set => ({
  valor: '',
  setValor: valor => set(() => ({ valor: valor })),
}));

type Vigencia = {
  vigencia: string;
  setVigencia: (vigencia: string) => void;
};

export const useVigenciaStore = create<Vigencia>(set => ({
  vigencia: '',
  setVigencia: vigencia => set(() => ({ vigencia: vigencia })),
}));
